import { Checkbox, Drawer, Flex, Link, Text } from '@servicetitan/anvil2';
import { useEffect, useState } from 'react';
import { SecondLookDisclosureText } from './SecondLookDisclosureText';
import { DisclosureDataStore } from './DisclosureStore';
import {
    resolveSecondLookDisclosureText,
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';

export const WellsFargoDisclosure = () => {
    const [showTerms, setShowTerms] = useState(false);
    const { setAgreedToDisclosures } = DisclosureDataStore.useStore();
    const {
        prequalAcknowledgementText,
        turnsCoapplicationDisclosureText,
        firstLookDataSharingDisclosureText,
        firstLookLenderDisclosureName,
    } = useProviderConfig();
    const { secondLookProvider } = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();
    const isFinturfSecondLook = secondLookProvider?.toLowerCase() === 'finturf';
    const secondLookDisclosureText = isFinturfSecondLook
        ? `I also understand that if ${firstLookLenderDisclosureName} has no available offers, the above information will be sent to Finturf for the purpose of obtaining a loan or lease, which will be done via a soft pull of my credit and will not impact my credit score.`
        : resolveSecondLookDisclosureText(turnsCoapplicationDisclosureText, secondLookProvider);

    // The checkbox is uncontrolled and starts unchecked on every mount.
    // Sync the store to match, so a stale `true` from a previous submission
    // doesn't leave the submit button enabled while the checkbox is unchecked.
    useEffect(() => {
        setAgreedToDisclosures(false);
    }, [setAgreedToDisclosures]);

    return (
        <Flex direction="row" gap="2" alignItems="flex-start">
            <Checkbox
                aria-label={`I agree to Wells Fargo prequalification and ${secondLookProviderName} financing terms`}
                onChange={(_, state) => setAgreedToDisclosures(state?.checked ?? false)}
            />
            <Flex direction="column" gap="4">
                <Text>{prequalAcknowledgementText}</Text>
                <Text>
                    {secondLookDisclosureText}{' '}
                    <Link onClick={() => setShowTerms(true)}>View terms</Link>
                </Text>
                {firstLookDataSharingDisclosureText && (
                    <Text>{firstLookDataSharingDisclosureText}</Text>
                )}
            </Flex>
            {showTerms && (
                <Drawer open onClose={() => setShowTerms(false)}>
                    <Drawer.Header>{secondLookProviderName} Financing Terms</Drawer.Header>
                    <Drawer.Content>
                        <SecondLookDisclosureText />
                    </Drawer.Content>
                </Drawer>
            )}
        </Flex>
    );
};
